import { Pipe, PipeTransform } from '@angular/core';

import { JobLocation } from '@shared/models/job-location';

@Pipe({
  name: 'mojoLocation',
})
export class JobLocationPipe implements PipeTransform {
  transform(jobLocations: JobLocation[] | JobLocation, ...args: any[]): string {
    jobLocations = [].concat(jobLocations);
    return [...jobLocations]
      .filter(Boolean)
      .map((jobLocation) => {
        if (jobLocation.city || jobLocation.countryName) {
          return [jobLocation.city, jobLocation.state, jobLocation.countryName].filter((v) => !!v && !v.match(/^\d+$/)).join(', ') + '\n';
        } else {
          return jobLocation.location;
        }
      })
      .join('');
  }
}
